var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0C7.84989 0 0 7.84989 0 17.5C0 27.1501 7.84989 35 17.5 35C27.1501 35 35 27.1501 35 17.5C35 7.84989 27.1501 0 17.5 0ZM26.0499 14.0943C26.0575 14.2739 26.0621 14.4565 26.0621 14.6399C26.0621 20.2079 21.8217 26.6304 14.0692 26.6304C11.6892 26.6304 9.47283 25.9327 7.6087 24.7366C7.93815 24.7762 8.27217 24.7952 8.6138 24.7952C10.589 24.7952 12.4067 24.1226 13.8478 22.992C12.0035 22.9585 10.4483 21.7373 9.91033 20.0649C10.1683 20.1143 10.4323 20.141 10.7047 20.141C11.0889 20.141 11.4617 20.09 11.814 19.9926C9.8875 19.6038 8.435 17.9025 8.435 15.8596C8.435 15.8413 8.435 15.8238 8.435 15.8063C9.00337 16.1221 9.65239 16.3123 10.344 16.3343C9.21185 15.5773 8.46924 14.2884 8.46924 12.826C8.46924 12.0537 8.6762 11.3301 9.03913 10.7062C11.1186 13.2559 14.2245 14.9336 17.7267 15.1101C17.6545 14.8012 17.6164 14.4801 17.6164 14.1499C17.6164 11.8224 19.5034 9.93543 21.8316 9.93543C23.0437 9.93543 24.1386 10.4467 24.9071 11.2662C25.8665 11.0775 26.7697 10.7267 27.5838 10.2443C27.2696 11.2274 26.6008 12.0537 25.7296 12.5757C26.5833 12.4722 27.3943 12.247 28.1514 11.9114C27.5868 12.7567 26.8724 13.5001 26.0499 14.0943Z",
    fill: "#4795DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.7cca77b19e06e1d2c08d17868da15bbd.svg";
export { ForwardRef as ReactComponent };